import type { ConnectionDetails } from "@client/types/connection.types";
import { buildChatEmbedUrlFromParts, resolveOriginFromEnvValues } from "@shared/utils/chatEmbed";
import { getNextjsEmbedOrigin } from "@/lib/env";

export function isMeetChatEnabled(
  connectionDetails: ConnectionDetails | null | undefined,
  fallbackChatId?: string | null
): boolean {
  if (!connectionDetails) return false;

  const chatId = connectionDetails.chatId ?? fallbackChatId ?? null;
  const chatEnabled = connectionDetails.chatEnabled === true;

  return chatEnabled && Boolean(chatId);
}

export function resolveMeetChatId(
  connectionDetails: ConnectionDetails | null | undefined,
  fallbackChatId?: string | null
): string | null {
  return connectionDetails?.chatId ?? fallbackChatId ?? null;
}

/** Client fallback when join API did not return chatEmbedUrl (env must be set at build time). */
export function buildChatEmbedUrl(chatId: string, locale = "en"): string | null {
  const origin = resolveOriginFromEnvValues(getNextjsEmbedOrigin());

  if (!origin || !chatId?.trim()) return null;

  return buildChatEmbedUrlFromParts({
    origin,
    locale: locale.trim() || "en",
    chatId: chatId.trim()
  });
}

/**
 * Prefer server-built URL from join response; fall back to client env only if needed.
 */
export function resolveChatEmbedUrl(
  connectionDetails: ConnectionDetails | null | undefined,
  chatId: string,
  locale = "en"
): string | null {
  if (connectionDetails?.chatEmbedUrl) {
    return connectionDetails.chatEmbedUrl;
  }

  return buildChatEmbedUrl(chatId, locale);
}
